<template>
  <div id="app">
    <vue-extend-layouts />
  </div>
</template>

<script>
import VueExtendLayouts from 'vue-extend-layout'
import './assets/css/2.0/main.css'

export default {
  name: 'App',
  components: { VueExtendLayouts }
}
</script>

<style>
body {
  overflow-x: hidden;
}
</style>

